import metaModel from '~/shared/src/utilities/metaModel';
import Item, {
    ItemAttributesForCreation
} from '~/shared/src/ci/Item';
import ciHelper from '~/shared/src/utilities/dataUtils';

import {DATA_ADD_ITEM} from '~/frontend/src/constants';
import {
    AppDispatch,
    StoreState,
    Thunk
} from '~/frontend/src/store';
import {setElusiveData} from '~/frontend/src/actions/elusiveData';


/**
 * @memberOf! Actions
 *
 * @param {String} dataContext
 * @param {Item|ItemAttributesForCreation} item
 * @param {Schema} schema
 * @param {string[]} [additionalElusiveDataContexts=[]]
 *
 * @return {void}
 */
const addItem = ( dataContext : string, item : Item | ItemAttributesForCreation, schema : Schema | undefined = undefined, additionalElusiveDataContexts : string[] = [] ) : Thunk<Item> => ( dispatch : AppDispatch, getState : () => StoreState ) : Item => {
    schema = schema ?? global.data[ dataContext ]?.schema ?? global.schema;

    dispatch( {
        type: DATA_ADD_ITEM,
        dataContext,
        item: item instanceof Item ? item.toJSON() : item,
        schema,
        additionalElusiveDataContexts
    } );

    if ( item ) {
        let isNewItem = false;

        // if item is given as ItemAttributes object here, check for existing one or create the new Item
        if ( !( item instanceof Item ) ) {
            const existingItem = item.key ? ciHelper.findItem( dataContext, item.itemTypeId, item.key ?? '' ) : false;

            if ( existingItem ) {
                item = existingItem;
            }
            else {
                isNewItem = true;
                item = new Item( item, dataContext, schema );
            }
        }

        if ( !isNewItem && item.isDeleted() ) {
            item = item.reset().clone();
            item.statusId = metaModel[ schema ].getStatus( 'active' )!.id;
        }

        // update ElusiveData
        additionalElusiveDataContexts.unshift( dataContext );
        for ( const elusiveDataContext of additionalElusiveDataContexts ) {
            const elusiveData    = getState().elusiveData?.[ elusiveDataContext ],
                  newElusiveData = {
                      ...elusiveData,
                      data: {
                          ...elusiveData?.data,
                          items     : {
                              ...elusiveData?.data?.items,
                              [ item.id ]: ( elusiveData?.data?.items?.[ item.id ] ?? 0 ) + 1
                          },
                          references: elusiveData?.data?.references ?? {}
                      }
                  };

            dispatch( setElusiveData( elusiveDataContext, newElusiveData ) );
        }
    }

    return item;
}
export type AddItem = typeof addItem;

export default addItem;
